import Keycloak from 'keycloak-js';
import { requiredEnv } from '../lib/env';

const keycloakConfig = {
  url: requiredEnv('VITE_KEYCLOAK_URL'),
  realm: requiredEnv('VITE_KEYCLOAK_REALM'),
  clientId: requiredEnv('VITE_KEYCLOAK_CLIENT_ID'),
};

const keycloak = new Keycloak(keycloakConfig);

export default keycloak;
